import React from 'react'

import WhatsAppWidget from 'react-whatsapp-widget'
import 'react-whatsapp-widget/dist/index.css'
import './whatsapp.css'

const Whatsapp = () => {
    return (
        <>
            {/* <WhatsAppWidget className="whatsapp" phoneNumber='+88017890678711' textReplyTime="Typically replies within a day" message="What can I do for you?" companyName="Crazy Front-End Developer" sendButton="Send"/> */}
        </>
    );
};

export default Whatsapp;